let d = window.define;
d("@ember/string/cache", function () {
  return esc(require("@ember/string/cache"));
});
d("@ember/string/index", function () {
  return esc(require("@ember/string/index"));
});
import "@ember/string/-embroider-implicit-modules.js";
import esc from "../../../../../../../../../../node_modules/@embroider/macros/src/addon/es-compat2";